import React from 'react';
import ColorPickerField from './ColorPickerField';

const LineProperties = ({ shape, onChange }) => {
  const handleLineColorChange = (color) => {
    onChange({ ...shape, stroke: color });
  };

  const handleLineThicknessChange = (event) => {
    const newStrokeWidth = parseInt(event.target.value);
    onChange({ ...shape, strokeWidth: newStrokeWidth });
  };

  return (
    <div className="shape-specific-properties">
      <ColorPickerField
        label="Line Color"
        color={shape.stroke}
        onChange={handleLineColorChange}
      />
      <div className="shape-property">
        <label className="shape-property-label">Thickness</label>
        <select value={shape.strokeWidth || ''} onChange={handleLineThicknessChange} style={{width: '60px'}}>
          {[...Array(30).keys()].map(i => (
            <option key={i + 1} value={i + 1}>
              {i + 1}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default LineProperties;
